import { useStyletron } from 'baseui';
export const Statistic = props => {
  const [css] = useStyletron();
  const pre = props.prefix ? props.prefix : '';
  const main = props.value || props.value === 0 ? Number(props.value).toLocaleString(undefined, {
    minimumFractionDigits: 2
  }) : '';
  const suf = props.suffix ? props.suffix : '';
  return <>
      <p className={css({
      fontSize: '0.75rem',
      color: '#666666'
    })}>
        {props.title}
      </p>
      <p className={css({
      fontSize: '1.5rem',
      fontWeight: 700
    })}>
        {props.loading ? 'Loading...' : `${pre}${main} ${suf}`}
      </p>
    </>;
};
const ConvertedFeeStatistic = props => {
  const [css] = useStyletron();
  return <div className={css({
    paddingTop: '1rem'
  })}>
      <Statistic title={props.title} value={props.value} prefix={props.prefix} suffix={props.suffix} loading={props.loading} />
      <p className={css({
      fontSize: '0.75rem',
      color: '#666666'
    })}>
        Rate used:{' '}
        {props.loading ? '...' : new Date(props.conversionDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      })}
      </p>
    </div>;
};
export default ConvertedFeeStatistic;